import React from 'react';
import PropTypes from 'prop-types';

const UploadProgressBar = ({progress, processingLabel}) => {
  if (!(progress > 0 && progress < 100)) return null;
  return (
    <div className='mb-2 w-[100%]'>
      <div className='mb-1 flex items-center gap-2'>
        <div className='mt-1 text-xs text-gray-300'>{progress}%</div>
        {progress === 99 && processingLabel && (
          <div className='mt-1 text-xs text-yellow-300'>{processingLabel}</div>
        )}
      </div>
      <progress
        value={progress}
        max={100}
        className='custom-progress-bar block h-2 w-full appearance-none overflow-hidden rounded bg-gray-700 transition-all duration-200'
        style={{
          accentColor: '#3387DF'
        }}>
        {progress}%
      </progress>
    </div>
  );
};

UploadProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  processingLabel: PropTypes.string
};

export default UploadProgressBar;
